export class AppConsts {
    static readonly GrafanaConfigurationName = 'grafana';
    static readonly AppName = 'Seedling Supply Reception';
    static readonly SessionLocationId = 'locationId';
    static readonly SessionVendorId = 'vendorId';
    static readonly UserId = 'userId';
    static readonly UserName = 'userName';
    static readonly UserUsername = 'userUsername';

    static readonly Routes = {
        TripJourneyReception: '/trip-journey-reception',
        TripJourneyReceptionCheck: '/trip-journey-reception/check',
        DepositsDocuments: '/deposits-documents',
        Map: '/map',
        Materials: '/materials'
    };

    static readonly JourneyEnumOrder: Record<string, number> = {
        Arrived: 1,
        Dispatch: 2,
        OnRoute: 3,
        Completed: 4,
        Canceled: 5
    };

    static readonly DateHourFormat = 'HH:mm';
    static readonly DateTimeShortFormat = 'dd/MM/yyyy';
    static readonly DateTimeFormat = 'dd/MM/yyyy HH:mm:ss'
    static readonly DateTimeNoSecondsFormat = 'dd/MM/yyyy HH:mm'
    static readonly DayMonthHourMinuteFormat  = 'dd/MM HH:mm'
    static readonly NotApplyText = 'N/A';
    static readonly UTCFormat = 'UTC';


    static readonly CurrentUser ='currentUser'

    static readonly QrErrorCorrectionLevel = 'M';
    static readonly QRReaderTraySeparator = ',';

    static readonly OnRouteStatus = 'onRoute';
    static readonly ReceivedStatus = 'received';

    static readonly DegreeToRadian = Math.PI / 180;

    static readonly DeclaredVSReceptionedDefault = "0/0"

    static readonly StatusStyleClass = {
        Dispatch: 'status-dispatch',
        Accepted: 'status-accepted',
        Edited: 'status-edited',
    };

    static readonly ForestryVendor = 57;
}